import get from 'lodash/get';
import { createSelector } from 'reselect';

import { ClosingLessonModalStore } from './typings';

const modalSelector = (storeState: object) => get(storeState, 'closingLessonModal', {});

export const getShouldShowClosingLessonModal = createSelector(
    modalSelector,
    (state: ClosingLessonModalStore): boolean => get(state, 'isOpened', false)
);
